import { Link } from "react-router-dom";
import CompareCard from "@/components/feature/CompareCard";
import { compareList } from "@/mocks/compare";

export default function CompareSection() {
  const [c1, c2] = compareList;
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-container px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-secondary-700">对比分析</span>
            <h2 className="mt-2 text-2xl text-foreground-950 md:text-3xl">同类事件，谁的解释更经得起推敲</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              把两个易混淆的概念、两种公关打法摆上台面逐行对比，辨清差别，避免被单方带节奏。
            </p>
          </div>
          <Link
            to="/duibi"
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-secondary-600"
          >
            查看全部对比手册 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <CompareCard topic={c1} priority />
          <CompareCard topic={c2} />
        </div>
      </div>
    </section>
  );
}